import axios from "axios";
import Cookies from "js-cookie";
import i18n from '../i18n';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

api.interceptors.request.use((config) => {
  const token = Cookies.get("token");
  const currentLanguage = i18n.language; 
  config.headers['Accept-Language'] = currentLanguage;

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default api;
